import {
  Box,
  Button,
  Flex,
  FormControl,
  FormErrorMessage,
  FormLabel,
  Input,
  Text,
} from "@chakra-ui/react";
import { useState } from "react";
import PageLeadgen from "@/components/PageLeadgen";
import ModalAuth from "@/components/user/ModalAuth";
import { useUserData, withUserData } from "@/contexts/UserDataContext";
import "@fontsource/raleway/400.css";
import { ChevronRightIcon, SearchIcon } from "@chakra-ui/icons";
import { useForm } from "react-hook-form";
import { LinkButton } from "@/components/shared/generic";
import { useAPI } from "@/contexts/APIContext";
import { captureFB, markFBLead } from "@/utils/analytics";
import { DATABASE_SIZE } from "@/utils/profile";

const Page = () => {
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm();

  const api = useAPI();
  const [loading, setLoading] = useState(false);
  const [sent, setSent] = useState(false);

  const onSubmit = async ({ email }) => {
    setLoading(true);
    await api.post("features/leadgen", false, { email, resourceId: "internships" });
    captureFB("Lead", { content_name: "Internship Email Templates" });
    setSent(true);
  };

  return (
    <>
      <Box>
        <PageLeadgen
          header="Internship cold email templates—free and professionally reviewed."
          img="/images/leadgen/internships.png"
        >
          <Text fontSize={{ base: "md", md: "xl" }} fontFamily="heading">
            Land the prestigious summer opportunity you&apos;re dreaming of.
            <Text as="span" display={{ base: "none", md: "initial" }}>
              {" "}
              We&apos;ve got templates for research, medical internships, computer science, and
              more.
            </Text>
          </Text>
          {sent ? (
            <Text mt={4} fontWeight="bold" fontSize="lg" fontFamily="heading">
              Sent! Check your inbox.
            </Text>
          ) : (
            <form onSubmit={handleSubmit(onSubmit)}>
              <Flex direction={{ base: "column", md: "row" }} gap={2}>
                <FormControl isInvalid={!!errors.email}>
                  <Input
                    size="lg"
                    type="email"
                    minW={{ md: 96 }}
                    border="3px solid lightgray"
                    placeholder="What's your email address?"
                    {...register("email", { required: "Please enter an email address." })}
                  />
                  {errors.email && <FormErrorMessage>{errors.email.message}</FormErrorMessage>}
                </FormControl>
                <Button
                  isLoading={loading}
                  type="submit"
                  size="lg"
                  minW="none"
                  color="white"
                  rightIcon={<ChevronRightIcon />}
                  colorScheme="green"
                >
                  Send me the templates
                </Button>
              </Flex>
            </form>
          )}
        </PageLeadgen>
        <PageLeadgen
          navbar={false}
          minH={0}
          py={0}
          pb={20}
          flexDir={{ base: "column", md: "row-reverse" }}
          header={`Or, read through ${DATABASE_SIZE.applications}+ college applications at Harvard, Stanford, and more.`}
          img="/images/leadgen/profiles.png"
        >
          <LinkButton colorScheme="black" size="lg" leftIcon={<SearchIcon />} href="/profiles">
            Read successful applicatinos
          </LinkButton>
        </PageLeadgen>
      </Box>
    </>
  );
};

export default Page;
